exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table .el-input__inner {\n  height: 25px;\n}\n.table .el-input {\n  width: 67%;\n}\n.dealerStock .addform .el-dialog {\n  /* margin-top: 2vh !important; */\n}\n.function ol li.disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\n", ""]);

// exports
